import GenericModel from '../generic-model';
import Contact from '../Contact/contact';
import Company from './company';
import Quotation from '../quotation';

export default class ProjectContact extends GenericModel {
  contact: Contact;
  company: Company;
  projectManager: boolean;
  quotations?: Quotation[];

  contactUserId?: number;

  constructor() {
    super();
    this.projectManager = false;
    this.contact = new Contact();
    this.company = new Company();
  }
}
